module.exports = __webpack_public_path__ + "static/media/1025789.10cc54b3.jpg";